import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Card from "../products/Card";
import categoryAPI from "../../api/categoryApi";

const DetailPage = () => {
  const { "*": slug } = useParams();
  const [item, setItem]                   = useState({});
  const [subcategories, setSubCategories] = useState([]);
  const [products, setProducts]           = useState([]);
  const [metaData, setMetaData]           = useState({});

  const fetchCategoryDetail = async () => {
    try {
      const res = await categoryAPI.details(slug);
      console.log(res)

      if (res.code === 200) {
        const result = res.data;

        setItem(result?.category);                    // { _id, name, slug, slugPath, image, description }
        setSubCategories(result?.subcategories ?? []); // array of subcategory objects
        setProducts(result?.products ?? []);           // [{ _id, title, slug, thumbnail, price, mrp, discount, shortDescription, brand, ... }]
        setMetaData(result?.category?.meta ?? {});    // meta may not exist in API — safe fallback
      }
    } catch (err) {
      console.error("Error loading category detail:", err);
    }
  };

  useEffect(() => {
    fetchCategoryDetail();
  }, [slug]);

  // Unique brands derived from product.brand field (API has no separate brands array)
  const brands = [
    ...new Map(
      products
        .filter((p) => p.brand)
        .map((p) => [
          p.brand,
          {
            name: p.brand,
            slug: p.brand.toLowerCase().replace(/\s+/g, "-"),
          },
        ])
    ).values(),
  ];

  return (
    <div className="ith-cat-page">
      <div className="container-fluid">
        <div className="row">

          {/* ── LEFT SIDEBAR ── */}
          <div className="col-12 col-lg-3">
            <aside className="ith-cat-sidebar">

              {/* <h2 className="ith-cat-sidebar__heading">
                Category: {item.name}
              </h2>
              <hr className="ith-cat-sidebar__divider" />

              <ul className="ith-cat-sidebar__list">
                {subcategories.map((sub) => (
                  <li key={sub._id}>{sub.name}</li>
                ))}
              </ul> */}

              {/* FeaturCed */}
              {/* <h3 className="ith-cat-sidebar__section-title">Featured</h3>
              <hr className="ith-cat-sidebar__divider" /> */}
              {/* <ul className="ith-cat-sidebar__featured">
                {data.featured.map((item) => (
                  <li key={item.id}>
                    <a
                      href={`/products/${item.slug}`}
                      className="ith-cat-sidebar__featured-item"
                    >
                      <img
                        src={item.image}
                        alt={item.name}
                        className="ith-cat-sidebar__featured-img"
                      />
                      <p className="ith-cat-sidebar__featured-name">
                        {item.name}
                      </p>
                    </a>
                  </li>
                ))}
              </ul> */}

              {/* Products Available At — derived from product.brand */}
              <h3 className="ith-cat-sidebar__section-title">
                Products Available At
              </h3>
              <hr className="ith-cat-sidebar__divider" />
              <ul className="ith-cat-sidebar__brands">
                {brands.map((brand, i) => (
                  <li key={i}>
                    <a href={`/brand/${brand.slug}`}>{brand.name}</a>
                  </li>
                ))}
              </ul>

            </aside>
          </div>

          {/* ── RIGHT CONTENT ── */}
          <div className="col-12 col-lg-9 d-flex flex-column gap-3">

            <div className="ith-cat-content-box">
              {/* Category label */}
              <p className="ith-cat-content__cat-label">{item.name}:</p>

              {/* Description — item.description (not products.description) */}
              {item?.description && (
                <p
                  className="ith-cat-content__description"
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
              )}
            </div>

            {/* Product Cards Grid */}
            <div className="ith-cat-content__grid">
              {products.map((product) => (
                <Card product={product}
                />
              ))}
            </div>

            {/* Empty state */}
            {products.length === 0 && (
              <div className="text-center py-5 text-muted">
                <p>No products found in this category.</p>
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailPage;